import { TextSelection } from "@tiptap/pm/state"

import type { Editor } from "@tiptap/core"

/**
 * Enter in a one-line field (a label, a title, a caption) moves the caret to
 * the start of the next textblock instead of trying to split the field, which
 * the schema has no room for.
 */
export function enterMovesToNextLine(
	editor: Editor,
	lineTypes: string[],
): boolean {
	return editor.commands.command(({ state, tr, dispatch }) => {
		const { $from, empty } = state.selection
		if (!empty || !lineTypes.includes($from.parent.type.name)) return false
		const after = $from.after()
		let target = -1
		state.doc.nodesBetween(after, state.doc.content.size, (node, pos) => {
			if (target >= 0) return false
			if (node.isTextblock) {
				target = pos + 1
				return false
			}
			return true
		})
		if (target >= 0 && dispatch) {
			tr.setSelection(TextSelection.create(tr.doc, target))
		}
		return true
	})
}
